<template>
	<div class="shape-wrap">
		<component :is="shapesMap[shape]"></component>
	</div>
</template>

<script>
import IconCircle from '@/components/icons/IconCircle.svg'
import IconSquare from '@/components/icons/IconSquare.svg'
import IconTriangle from '@/components/icons/IconTriangle.svg'

export default {
	name: 'Shape',
	props: {
		shape: {
			type: String,
			required: true,
		},
	},
	components: {
		IconCircle,
		IconSquare,
		IconTriangle,
	},
	data() {
		return {
			shapesMap: {
				squares: IconSquare,
				circles: IconCircle,
				triangles: IconTriangle,
			},
		}
	},
}
</script>

<style lang="scss" scoped>
.shape-wrap {
	position: relative;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.icon-svg {
	width: auto;
	height: 100%;
	overflow: visible;
	transition: stroke-width 0.2s $ease-out-quad, stroke 0.2s $ease-out-quad, fill 0.2s $ease-out-quad;
}
</style>
